<div class="settings-dropdown">
  <div class="settings-dropdown-info">
    <p class="settings-dropdown-title">{{ title | translate }}</p>
    <p class="settings-dropdown-description" *ngIf="description">
      {{ description | translate }}
    </p>
  </div>
  <div class="settings-dropdown-options">
    <app-pencil-searchable-dropdown
      [dataSource]="options"
      [selectedItem]="selectedItem$ | async"
      [bindValue]="bindValue"
      [bindLabel]="bindLabel"
      [placeholder]="placeholder"
      [searchable]="false"
      (selectedItemChanged)="onItemSelected($event)"
    >
    </app-pencil-searchable-dropdown>
  </div>
</div>
